/* unplugin-vue-components disabled */import { render } from "./suzhouclose.vue?vue&type=template&id=6e57f066"
import script from "./suzhouclose.vue?vue&type=script&lang=js"
export * from "./suzhouclose.vue?vue&type=script&lang=js"

import "./suzhouclose.vue?vue&type=style&index=0&id=6e57f066&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/disney-mobile-ui-production-environment/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__